module.exports = __webpack_public_path__ + "static/media/face-outline-guide.9547ee57.svg";